<template>
    <!-- Single post-->
      <section class="section section-lg bg-default novi-background bg-cover">
        <!-- section wave-->
        <div class="container container-wide">
            <div class="row justify-content-sm-center">
                <img class="icon-success" src="/images/eowp/pg/payment-success.png" />
            </div>
            <div class="success-title">
                <span>受付が完了いたしました</span>
            </div>
            <div class="success-description">
              <span>ご登録のメールアドレス宛てに、受付完了メールを送信しています。ご確認ください。</span>
              <div class="success-notice" v-if="!this.eowp.syncOnQueue">
                <span>完了メールが届かない場合、処理が正常に行われていない可能性がございます。</span>
                <span>大変お手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">「英辞郎 on the WEB」お問い合わせフォーム</a>からお問い合わせくださいますようお願い申し上げます。</span>
              </div>
              <div class="success-notice" v-if="this.eowp.syncOnQueue">
                <span>完了メールが届かない場合、処理に時間がかかっている可能性がございます。お手数ですが、<a target="_self" href="/account">アカウントページ</a>にて詳細のご確認をお願いいたします。</span>
              </div>
              <div class="success-notice">
                <span>次回以降のお支払いに利用するクレジットカードを変更したい場合は、 <a target="_self" href="/account">アカウントページ</a>の「カード情報の変更・更新」からお手続きいただけます。</span>
              </div>
              <div class="success-button">
                <div class="annotation">「英辞郎 on the WEB Pro」へのログインはこちら</div>
                <div class="button button-xs button-default-outline" @click="externalLink('https://eowpf.alc.co.jp/login')">ログイン</div>
              </div>
            </div>
        </div>
      </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.success-button div.annotation{
    font-size: 14px;
}
.success-button div.button{
    max-width: 320px;
    margin-top: 8px!important;
}
.success-button{
    position: relative;
    display: block;
    padding-top: 40px;
    margin: 0 auto;
}
.success-description {
    text-align: center;
    padding-bottom: 9%;
    mergin-top:5%;
}
.success-description span {
    display: block;
}
.success-description span a{
    color: #838386;
    text-decoration: underline;
}
.success-notice{
    margin-top: 20px;
}
.success-title {
    text-align: center;
    font-size: 30px;
    margin: 20px 0;
    font-weight: 1000;
}
.icon-success {
    width: 150px;
}
.section {
    padding-top: 50px !important;
    height: 100%!important;
    position: relative;
    display: block;
}
@media (min-width: 150px) {
    .justify-content-sm-center {
        justify-content: center !important;
    }
}

</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Utils from '../../../js/helpers/Utils';
import BaseModel from '../../../js/models/BaseModel';

export default {
    data(){
        return {
            eowp: {
                syncOnQueue: false,
            }
        };
    },
    computed: {
        ...mapGetters({
            successFlag: 'pg/success_flag',
            updateCCResult: 'pg/update_cc_result',
        }),
    },
    created(){
        if(Utils.isEmpty(this.successFlag)){
            this.$router.push("/products"); // Comment-out this line if we want to test the success page directly
        }
        this.couponClearStates(); //Clear coupons and promoCodes out of the Vuex state now that payment succeeded. 
        this.backendDomainUrl = BaseModel.getHost();
        let params = Utils.getParameters(window.location.href);
        if(params && params.sync && params.sync == 1){
            this.eowp.syncOnQueue = true;
        }
    },
    methods: {
        ...mapActions({
            trackClickEvent: 'ga/trackClickEvent',
            couponClearStates: 'coupon/clearStates',
        }),
        externalLink(url) {
           window.open(url);
        }
    }
};
</script>
